import React from "react";
import AlertModal from "../../../../components/basic/AlertModal";
import InputBasic from "../../../../components/input/InputBasic";
import TextAreaBasic from "../../../../components/input/TextAreaBasic";
import ReadOnlyInputBasic from "../../../../components/input/ReadOnlyInputBasic";
import Th_title from "../../../../components/Th_title";
import UserGroupFormTable from "./UserGroupFormTable";
import "../userGroupEditForm.css";

const UserGroupInfo = ({data, update, remove}) => {
    const group = data?.data;

    return (
        <div className="user-group-edit-form company-manage-editor-form">
            <div className="user-group-edit-form__section">
                <div className="user-group-edit-form__section-body">
                    <UserGroupFormTable>
                        <tbody>
                            <tr>
                                <Th_title title="등록일시" className="fieldset-td" colspan={1}>
                                    <ReadOnlyInputBasic type="date" value={group?.createdAt} />
                                </Th_title>
                                <Th_title title="수정일시" className="fieldset-td" colspan={1}>
                                    <ReadOnlyInputBasic type="date" value={group?.updatedAt} />
                                </Th_title>
                            </tr>
                            <tr>
                                <Th_title title="사용자그룹명" className="fieldset-td" colspan={3} required>
                                    <InputBasic target="name" data={data} required />
                                </Th_title>
                            </tr>
                            <tr>
                                <Th_title title="상세설명" className="fieldset-td" colspan={3}>
                                    <TextAreaBasic target="description" data={data} />
                                </Th_title>
                            </tr>
                        </tbody>
                    </UserGroupFormTable>
                </div>
            </div>
            <div className="user-group-edit-form__actions code-manage-scope">
                {remove && (
                    <AlertModal
                        triggerName="삭제"
                        handler={remove}
                        triggerClassName="code-manage-delete-btn"
                        actionName="삭제하기"
                        title="삭제하시겠습니까?"
                    />
                )}
                {update && (
                    <AlertModal
                        triggerName="수정"
                        handler={update}
                        triggerClassName="save-btn"
                        actionName="확인"
                        title="수정을 완료합니다."
                    />
                )}
            </div>
        </div>
    );
};

export default UserGroupInfo;
